import login from './login'

const namespaced = true

export default {
  namespaced,
  modules: {
    login
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/token/forms/index.js